"use client";

import { useSession } from "next-auth/react";
import { useEffect } from "react";
import { useAuthStore } from "@/store/authStore";

/**
 * Syncs the NextAuth session into the Zustand auth store so that auth data
 * (token, username, role, organisationId, accountId, onboarded)
 * is accessible anywhere without calling useSession().
 *
 * Mount this once inside NextAuthProvider, above all page content.
 */
export default function AuthStoreProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const { data: session, status } = useSession();
  const { setAuth, clearAuth } = useAuthStore();

  useEffect(() => {
    if (status === "authenticated" && session?.user) {
      const user = session.user;
      setAuth({
        isAuthenticated: true,
        // token: user.backendToken ?? null,
        username: user.username ?? user.name ?? null,
        role: user.role ?? null,
        organisationId:
          user.organisationId != null ? Number(user.organisationId) : null,
        accountId: user.accountId ?? null,
        onboarded: user.onboarded ?? false,
        hasSubscription: (user as any).hasSubscription ?? false,
        subscriptionStatus: (user as any).subscriptionStatus ?? null,
      });
    } else if (status === "unauthenticated") {
      clearAuth();
    }
    // status === "loading" → leave store as-is until resolved
  }, [session, status, setAuth, clearAuth]);

  return <>{children}</>;
}
